import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
} from "antd";
import moment from "moment";

import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";

const targetAudience = [
  { name: "Dealer", label: "Dealer" },
  { name: "Customer", label: "Customer" },
  { name: "Specialist", label: "Specialist" },
];


const AddNotificationModal = ({ show, hide, data, refresh }) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [list, setList] = useState([]);
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [selectAudience, setSelectAudience] = useState();


  const getUsers = () => {
    request({
      url: (selectAudience === "Dealer" ? apiPath.listDealer : (selectAudience === "Customer" ? apiPath.listCustomer : apiPath.listSpecialist)) + `?page=1&limit=1000`,
      method: "GET",
      onSuccess: (data) => {
        if (!data.status) return;
        setList(data.data.list.docs);
      },
      onError: (err) => {
        console.log(err);
      }
    })
  }

  const onCreate = (values) => {
    const payload = {
      title: values.title,
      audience: values.audience,
      user: values.user,
      type: values.type,
      message: values.message,
      whatsApp: values.whatsApp,
    };

    console.log(payload, "payload");

    setLoading(true);

    request({
      url: apiPath.notification,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleChange = (val) => {
    form.setFieldValue("user", val)
  }

  useEffect(() => {
    getUsers();
    if (!!data) {
      form.setFieldsValue({
        ...data,
      });
      setSelectAudience(data.audience);
    }
  }, [selectAudience]);

  return (
    <Modal
      width={750}
      open={show}
      okText="Add"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      className="tab_modal"
    >
      <Form id="create" form={form} initialValues={{ whatsApp: false, user: [] }} onFinish={onCreate} layout="vertical">
        <h4 className="modal_title_cls">
          {data ? "Edit Notification" : "Create Notification"}
        </h4>
        <Row gutter={[16, 0]} className="w-100">
          <Col span={24} sm={24} md={24}>
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Please Enter Notification Title",
                },
                {
                  max: 80,
                  message: "Title should not contain more then 80 characters!",
                },
                {
                  min: 2,
                  message: "Title should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                autoComplete="off"
                placeholder="Enter Notification Title"
              />
            </Form.Item>
          </Col>

          <Col span={24} sm={12} md={12}>
            <Form.Item
              name="audience"
              label="Select Audience"
              rules={[
                {
                  required: true,
                  message: "Please Select Audience",
                },
              ]}
            >
              <Select
                onChange={(value) => setSelectAudience(value)}
                placeholder="Select Audience"
                className="w-100"
              >
                {targetAudience.map((item, index) => (
                  <option key={item.name} value={item.name}>
                    <span className="cap">{item.label}</span>
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} sm={12} md={12}>
            <Form.Item
              name="user"
              label="User"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please Select User",
            //   },
            // ]}
            >
              <Select
                mode="multiple"
                onChange={handleChange}
                placeholder="Select User ( If No User Selected, Notify All User )"
                className="w-100"
              >
                {list.map((item, index) => (
                  <option key={item._id} value={item._id}>
                    <span className="cap">{item.name}</span>
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} md={12}>
            <Form.Item
              label="Message Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please select the message type",
                },
              ]}
            >
              <Input
                autoComplete="off"
                placeholder="Enter Notification Message"
              />
            </Form.Item>
          </Col>

          <Col span={24} sm={24} md={12}>
            <Form.Item
              label="Notification Message"
              name="message"
              rules={[
                {
                  required: true,
                  message: "Please Enter Notification Message",
                },
                {
                  max: 280,
                  message:
                    "Message should not contain more then 280 characters!",
                },
                {
                  min: 2,
                  message: "Message should contain at least 2 characters!",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                autoComplete="off"
                placeholder="Enter Notification Message"
              />
            </Form.Item>
          </Col>

          <Col span={24} sm={12}>
            <Form.Item
              label="Sent Via:"
              name="whatsApp"
            >
              <Radio.Group defaultValue={false}>
                <Radio value={false}>Push Notify</Radio>
                <Radio value={true}>WhatsApp Notify</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
  );
};

export default AddNotificationModal;
